import React from 'react';
import { Phone } from 'lucide-react';
export function SurveyFooter() {
  return <div className="flex flex-col items-center justify-center gap-2 mt-12 mb-8 text-[#0b2a4a] text-sm font-medium" data-id="element-16" data-mp="1wxwem6tv1ipl">
      <a href="https://www.krnwtr.nl" target="_blank" rel="noopener noreferrer" className="hover:text-[#14b8a6] transition-colors" data-id="element-17" data-mp="21wpqjuti11nn">
        www.krnwtr.nl
      </a>
      <div className="flex items-center gap-2" data-id="element-18" data-mp="199d6brat95xi">
        <Phone className="w-4 h-4" data-id="element-19" data-mp="196h8s42vkj9l" />
        <a href="tel:0208088400" className="hover:text-[#14b8a6] transition-colors" data-id="element-20" data-mp="1e758rf930afy">
          020 808 84 00
        </a>
      </div>
    </div>;
}